import React, { FC } from 'react';
import { SelectProps } from 'antd';
import { filter, find } from 'lodash';
import { DefaultOptionType } from 'antd/lib/select';

import { useHandbook } from '~/controllers/handbook';

import Select from './Select';

export type Product = {
  id: 'CORPORATE_EXECUTIVE_CARD' | 'DIGITAL_BUSINESS_PAYMENT' | 'DIGITAL_TRAVEL_PAYMENT';
  pct: string;
  enabled: boolean;
  productPercentageBalance: number;
};

const DropDown: FC<
  SelectProps<string> & {
    dropDownKey: string;
    itemKey: string;
    parentKey?: string;
    selectedProducts?: Array<Product>;
  }
> = (props) => {
  const { dropDownKey, itemKey, parentKey, selectedProducts } = props;
  const handbook = useHandbook();
  const handbookValue = handbook.data?.handbooks?.find((item) => item.key === dropDownKey)?.values;

  const options = handbookValue?.map((item) => ({
    label: item.localizedValue,
    value: item.apiValue!,
    key: item.key,
  }));

  const pctProducts = find(selectedProducts, (product: Product) => product?.id === parentKey);
  const selectedProductPctValue = pctProducts?.pct || '';

  const crrOptions = handbookValue
    ?.map((item) => {
      if (Object.keys(item?.additionalParams || {}).includes(selectedProductPctValue)) {
        return { label: item.localizedValue, value: item.apiValue!, key: item.apiValue };
      }
      return undefined;
    })
    .filter((value) => value) as DefaultOptionType[] | undefined;

  const crrKeys = [
    'CashbackRedemptionRebateCEC',
    'CashbackRedemptionRebateDBP',
    'CashbackRedemptionRebateDTP',
    'CashbackRedemptionRebateMB',
  ];

  return (
    <Select
      key={itemKey}
      loading={handbook.isLoading}
      disabled={handbook.isLoading}
      showSearch
      options={crrKeys.includes(dropDownKey) ? crrOptions : options}
      {...props}
    />
  );
};

export default DropDown;
